
import { useStore } from '@/store'
import { defineComponent, ref } from 'vue'
import { computed, watch } from 'vue'
import bagsizeSettings from '@/settings/bagsize-settings.json'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import FormOption from '@/components/Form/FormOption.vue'
import Analytics from '@/singletons/analytics'
import FormTab from '@/components/Abstract/FormTab.vue'

export default defineComponent({
  name: 'FormBody',
  components: {
    FormTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const configBagsizeId = computed(() => store.getters.configBagsizeId)
    const options = computed(() => { return [bagsizeSettings.bagsizeOptions[0], bagsizeSettings.bagsizeOptions[1]] })
    let currentSelection = ref()

    // prettier-ignore
    watch(() => configBagsizeId.value, (config) => {
      currentSelection.value = config;
    }
    )

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_BAGSIZE, option.id)
      Analytics.instance.sendBagsizeEvent(option.id)
    }

    return {
      configBagsizeId,
      bagsizeSettings,
      onClick,
      currentSelection,
      options
    }
  }
})
